import { render, staticRenderFns } from "./RoleEditForm.vue?vue&type=template&id=7ca41aae&"
import script from "./RoleEditForm.vue?vue&type=script&lang=js&"
export * from "./RoleEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports